import { ParentComponent } from "solid-js";

export type CardVariant = "default" | "elevated" | "bordered";

export interface CardProps {
  variant?: CardVariant;
  class?: string;
}

const variantClasses: Record<CardVariant, string> = {
  default: "bg-surface border border-line",
  elevated: "bg-surface border border-line-strong",
  bordered: "bg-surface border border-line",
};

export const Card: ParentComponent<CardProps> = (props) => {
  const variantClass = () => variantClasses[props.variant ?? "default"];
  return (
    <div class={"rounded " + variantClass() + " " + (props.class ?? "")}>
      {props.children}
    </div>
  );
};
